import React from 'react';
import './Skills.css'; 
import Navbar from './Navbar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCode, faChartBar, faMicrochip, faPuzzlePiece, faSwimmer, faChess, faBaseballBall, faFutbol } from '@fortawesome/free-solid-svg-icons';

function Skills() {
  return (
    <div>
      <Navbar />
      <div className="skills-container">
        <div className="skills-category">
          <h2>Programming Languages</h2>
          <div className="skills-list">
            <div className="skill">
              <FontAwesomeIcon icon={faCode} />
              <p>Java</p>
            </div>
            <div className="skill">
              <FontAwesomeIcon icon={faCode} />
              <p>Python</p>
            </div>
            <div className="skill">
              <FontAwesomeIcon icon={faCode} />
              <p>Scala</p>
            </div>
          </div>
        </div>
        <div className="skills-category">
          <h2>Technical Skills</h2>
          <div className="skills-list">
            <div className="skill">
              <FontAwesomeIcon icon={faMicrochip} />
              <p>Android App Development</p>
            </div>
            <div className="skill">
              <FontAwesomeIcon icon={faChartBar} />
              <p>Machine Learning</p>
            </div>
            <div className="skill">
              <FontAwesomeIcon icon={faChartBar} />
              <p>Deep Learning</p>
            </div>
            <div className="skill">
              <FontAwesomeIcon icon={faPuzzlePiece} />
              <p>Data Structures & Algorithms</p>
            </div>
          </div>
        </div>
        <div className="skills-category">
          <h2>Soft Skills</h2>
          <div className="skills-list">
            <div className="skill">
              <FontAwesomeIcon icon={faPuzzlePiece} />
              <p>Creative</p>
            </div>
            <div className="skill">
              <FontAwesomeIcon icon={faPuzzlePiece} />
              <p>Problem Solving</p>
            </div>
            <div className="skill">
              <FontAwesomeIcon icon={faPuzzlePiece} />
              <p>Continuous Learning</p>
            </div>
          </div>
        </div>
        <div className="skills-category">
          <h2>Extra Curricular Activities</h2>
          <div className="skills-list">
            <div className="skill">
              <FontAwesomeIcon icon={faChess} />
              <p>Chess</p>
            </div>
            <div className="skill">
              <FontAwesomeIcon icon={faBaseballBall} />
              <p>Cricket</p>
            </div>
            <div className="skill">
              <FontAwesomeIcon icon={faSwimmer} />
              <p>Swimming</p>
            </div>
            <div className="skill">
              <FontAwesomeIcon icon={faFutbol} />
              <p>Fencing</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Skills;
